/*eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import vacio_img from "../../../assets/webp/asset.webp";
import { vehiclesSimulator } from "../../conexion/vehicles.conexion";
import { Link, useLocation } from "react-router-dom";
import { getSrcSet, getSizes, buildCmsUrl } from "../../../utils/imageHelper";


interface SeleccionComponentProps {
  vehiculo: any;
  CompararEvent: any;
  activeComparador: any;
  setActiveComparador: any;
}

declare const window: any;
const SeleccionComponent: React.FC<SeleccionComponentProps> = ({
  vehiculo,
  CompararEvent,
  activeComparador,
  setActiveComparador,
}) => {
  const location = useLocation();
  const [modelo, setModelo] = useState("");
  const [version, setVersion] = useState("");
  const [price, setPrice] = useState("");
  const [modelo2, setModelo2] = useState("");
  const [version2, setVersion2] = useState("");
  const [price2, setPrice2] = useState("");
  const [vehiculos, setVehiculos]: any = useState([]);
  const [isFixed, setIsFixed] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Escucha el evento de cambio de tamaño
    window.addEventListener("resize", handleResize);

    // Limpieza para evitar fugas de memoria
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    vehiclesSimulator().then(function (res: any) {
      let data: any[] = res.data.data;

      // Transformar el array de datos
      /* const transformedData =  data.flatMap((vehiculo: any) =>
        vehiculo.versions.map((version: any) => ({
          name: vehiculo.name,
          slug: vehiculo.slug,
          version: version.name,
          //price: version.price,
          //imageUrl: version.image?.formats?.large?.url || version.image?.url,
        }))
      );
  
      console.log(transformedData); */

      setVehiculos(data);
      setModelo(
        vehiculo !== undefined && vehiculo !== "" ? vehiculo : data[0]?.slug
      );
      setVersion(
        vehiculo !== undefined && vehiculo !== ""
          ? data?.find((item: any) => item.slug === vehiculo)?.versions[0]?.name
          : data[0]?.versions[0]?.name
      );
      setPrice(
        vehiculo !== undefined && vehiculo !== ""
          ? data?.find((item: any) => item.slug === vehiculo)?.versions[0]
              ?.price
          : data[0]?.versions[0]?.price
      );
    });
  }, []);

  useEffect(() => {
    if (activeComparador) {
      const handleScroll = () => {
        if (componentRef.current) {
          const componentTop = componentRef.current.getBoundingClientRect().top;
          const componentHeight = componentRef.current.offsetHeight;
          const scrollPosition = window.scrollY;

          // Condición: scroll > 60px + altura del componente
          if (scrollPosition > (screenWidth > 1200 ? 160 : 148)) {
            setIsFixed(true);
          } else {
            setIsFixed(false);
          }
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [activeComparador, screenWidth]);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div
      ref={componentRef}
      className={`seleccion-comparador-component ${
        activeComparador ? "active" : ""
      }`}
      /* style={
        isFixed && screenWidth > 1200
          ? {
              zIndex: 999,
              top: screenWidth > 1200 ? 60 : 48,
              position: "fixed",
            }
          : {}
      } */
    >
      <div
        className={`title-card-seleccion-comparador ${
          activeComparador ? "active" : ""
        }`}
      >
        <p>Comparando actualmente</p>
        <Link to={location.pathname} reloadDocument>
          Cambiar vehículos
        </Link>
      </div>
      <div
        className={`firts-card-seleccion-comparador ${
          activeComparador ? "active" : ""
        }`}
      >
        <h2 className={`title  ${activeComparador ? "hidden" : ""}`}>
          {vehiculos?.find((item: any) => item.slug === modelo)?.name +
            " " +
            version}
        </h2>
        <img
          className={`img-vehicle ${activeComparador ? "active" : ""}`}
          src={`${
            modelo !== undefined
              ? buildCmsUrl(vehiculos?.find((item: any) => item.slug === modelo)?.versions?.find((e: any) => e.name === version)?.image?.url)
              : vacio_img
          }`}
          srcSet={getSrcSet(vehiculos?.find((item: any) => item.slug === modelo)?.versions?.find((e: any) => e.name === version)?.image?.url || '')}
          sizes={getSizes('400px')}
          alt={`Imagen del vehículo Hyundai ${
            modelo || "desconocido"
          } versión ${version || "sin especificar"}`}
        />

        <div className={`info ${activeComparador ? "active" : ""}`}>
          <div className={`info-title`}>
            {vehiculos?.find((item: any) => item.slug === modelo)?.name +
              " " +
              version}
          </div>
          <div className="info-subTitle">Disponible desde</div>
          <div className="info-price">{formatCurrency(parseInt(price))} *</div>
          <Link
            onClick={() => setActiveComparador(false)}
            to={`/vehiculos/${modelo}#cotizacion`}
            className="info-btn-cotizar"
          >
            Cotiza
          </Link>
        </div>
        <div className={`seleccion ${activeComparador ? "hidden" : ""}`}>
          <label>Modelo</label>
          <select
            disabled
            name=""
            id=""
            value={modelo}
            onChange={(e) => {
              setModelo(e.target.value),
                setVersion(
                  vehiculos.find((item: any) => item.slug === e.target.value)
                    ?.versions[0].name
                );
            }}
          >
            {modelo === "" ? <option value=""></option> : null}
            {vehiculos.map((item: any, index: number) => (
              <option key={index} value={item.slug}>{item.name}</option>
            ))}

          </select>
        </div>
        <div className={`seleccion ${activeComparador ? "hidden" : ""}`}>
          <label>Versión</label>
          <select
            name=""
            id=""
            value={version}
            onChange={(e) => {
              setVersion(e.target.value),
                setPrice(
                  vehiculos
                    ?.find((item: any) => item.slug === modelo)
                    ?.versions.find((item: any) => item.name === e.target.value)
                    ?.price
                );
            }}
          >
            {vehiculos
              ?.find((item: any) => item.slug === modelo)
              ?.versions?.map((item: any, index: number) => (
                <option key={index} value={item.name}>{item.name}</option>
              ))}

          </select>
        </div>
        <div
          className={`alert ${
            modelo && version ? "alert-success" : "alert-warning"
          } ${activeComparador ? "hidden" : ""}`}
        >
          {modelo && version ? "Listo para comparar" : "Llena todos los campos"}
        </div>
      </div>
      <div
        className={`second-card-seleccion-comparador ${
          activeComparador ? "active" : ""
        }`}
      >
        <h2 className={`title  ${activeComparador ? "hidden" : ""}`}>
          {modelo2 !== undefined && modelo2 !== ""
            ? vehiculos?.find((item: any) => item.slug === modelo2)?.name
            : "Selecciona un vehículo" + " " + version2}
        </h2>
        <img
          className={`img-vehicle ${
            modelo2 !== undefined && modelo2 !== "" ? "" : "inactive"
          } ${activeComparador ? "active" : ""}`}
          src={`${
            modelo2 !== undefined && modelo2 !== ""
              ? buildCmsUrl(vehiculos?.find((item: any) => item.slug === modelo2)?.versions?.find((e: any) => e.name === version2)?.image?.url)
              : vacio_img
          }`}
          srcSet={getSrcSet(vehiculos?.find((item: any) => item.slug === modelo2)?.versions?.find((e: any) => e.name === version2)?.image?.url || '')}
          sizes={getSizes('400px')}
          alt={`${
            modelo2 !== undefined && modelo2 !== ""
              ? `Imagen del vehículo ${modelo2} versión ${version2}`
              : "Imagen no disponible"
          }`}
        />


        <div className={`info ${activeComparador ? "active" : ""}`}>
          <div className={`info-title`}>
            {vehiculos?.find((item: any) => item.slug === modelo2)?.name +
              " " +
              version2}
          </div>
          <div className="info-subTitle">Disponible desde</div>
          <div className="info-price">{formatCurrency(parseInt(price2))} *</div>
          <Link
            onClick={() => setActiveComparador(false)}
            to={`/vehiculos/${modelo2}#cotizacion`}
            className="info-btn-cotizar"
          >
            Cotiza
          </Link>
        </div>
        <div className={`seleccion ${activeComparador ? "hidden" : ""}`}>
          <label>Modelo</label>
          <select
            name=""
            id=""
            value={modelo2}
            onChange={(e) => {
              setModelo2(e.target.value),
                setVersion2(
                  vehiculos.find((item: any) => item.slug === e.target.value)
                    ?.versions[0].name
                ),
                setPrice2(
                  vehiculos?.find((item: any) => item.slug === e.target.value)
                    ?.versions[0]?.price
                );
            }}
          >
            {modelo2 === "" ? <option value=""></option> : null}
            {vehiculos
              .sort((a: any, b: any) => a.name.localeCompare(b.name))
              .map((item: any, index: number) => (
                <option key={index} value={item.slug}>{item.name}</option>
              ))}

          </select>
        </div>
        <div className={`seleccion ${activeComparador ? "hidden" : ""}`}>
          <label>Versión</label>
          <select
            name=""
            id=""
            value={version2}
            onChange={(e) => {
              setVersion2(e.target.value),
                setPrice2(
                  vehiculos
                    ?.find((item: any) => item.slug === modelo2)
                    ?.versions.find((item: any) => item.name === e.target.value)
                    ?.price
                );
            }}
          >
            {vehiculos
              ?.find((item: any) => item.slug === modelo2)
              ?.versions?.map((item: any, index: number) => (
                <option key={index} value={item.name}>{item.name}</option>
              ))}

          </select>
        </div>
        <div
          className={`alert ${
            modelo2 && version2 ? "alert-success" : "alert-warning"
          } ${activeComparador ? "hidden" : ""}`}
        >
          {modelo2 && version2
            ? "Listo para comparar"
            : "Llena todos los campos"}
        </div>
      </div>
      <div
        className={`btn-seleccion-comparar ${
          modelo !== undefined &&
          modelo !== "" &&
          modelo2 !== undefined &&
          modelo2 !== ""
            ? "active"
            : ""
        } ${activeComparador ? "hidden" : ""}`}
        onClick={() => CompararEvent(modelo, modelo2, version, version2)}
      >
        Comparar vehículos
      </div>

      <div className="legal-card-seleccion-comparador mt-4">
        *Las imágenes de los vehículos son de carácter ilustrativo, las
        versiones comercializadas en Colombia pueden variar en colores y
        accesorios según las distintas versiones.
      </div>
      {/* <div className="legal-card-seleccion-comparador">*Las imágenes son ilustrativas, algunas características de los
      vehículos de las imágenes pueden variar.</div> */}
    </div>
  );
};

export default SeleccionComponent;
